import React from "react";
import RecruitmentLandingPage from "../../recruitment-shared/pages/RecruitmentLandingPage";

export default function FacultyLandingPage() {
  return <RecruitmentLandingPage type="FACULTY" />;
}
